import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';

export const getValueFromLocalStorage = (key: string) => {
    if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(key) as string;
    }

    return null;
};

export const setValueToLocalStorage = (key: string, param: string) => {
    if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(key, param);
    }
};

export const removeValueFromLocalStorage = (key: string) => {
    if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem(key);
    }
};

export const removeQuestValuesFromLocalStorage = () => {
    removeValueFromLocalStorage(LOCAL_STORAGE_KEYS.CURRENT_QUEST_ACTION);
    removeValueFromLocalStorage(LOCAL_STORAGE_KEYS.CURRENT_QUEST_COOLDOWN);
    removeValueFromLocalStorage(LOCAL_STORAGE_KEYS.RETRY_TIME_MOTIVATION_SHOWN);
    removeValueFromLocalStorage(LOCAL_STORAGE_KEYS.CORRECT_STREAK_COUNT);
    removeValueFromLocalStorage(LOCAL_STORAGE_KEYS.INCORRECT_STREAK_COUNT);
    removeValueFromLocalStorage(LOCAL_STORAGE_KEYS.PRE_ROUND_COUNTDOWN);
};
